import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/components/PageHeader';
import { RuleWizard } from '@/components/rules/RuleWizard';

export function RuleCreatePage() {
  const navigate = useNavigate();
  return (
    <Container maxWidth="md" disableGutters>
      <PageHeader title="New rule" subtitle="Walk through the wizard to set up a mirror." />
      <RuleWizard
        onCancel={() => navigate('/rules')}
        onCreated={(rule) => navigate(`/rules/${rule.id}`)}
      />
    </Container>
  );
}
